import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';

export type Props = ApiMethodBase & {}

export const updateGaugeAutomation = ({
    eventEmitter,
}: Props) => {
    eventEmitter.emit(Event.updateGaugeAutomation);
};

